// extracted by mini-css-extract-plugin
export default {"space":"styles_space__n4ZgK","server-settings-space":"styles_server-settings-space__OfhLK"};